import {
  FETCH_APPLICATION_SETTINGS_FLAGS,
  FETCH_APPLICATION_SETTINGS_FLAGS_SUCCESS,
  FETCH_APPLICATION_SETTINGS_FLAGS_FAILURE,
  UPDATE_APPLICATION_SETTINGS_FLAGS,
  UPDATE_APPLICATION_SETTINGS_FLAGS_SUCCESS,
  UPDATE_APPLICATION_SETTINGS_FLAGS_FAILURE,
  CLEAR_DEV_CACHE,
  CLEAR_DEV_CACHE_SUCCESS,
  CLEAR_DEV_CACHE_FAILURE,
  MATERIALIZED_VIEW_REFRESH,
  MATERIALIZED_VIEW_REFRESH_SUCCESS,
  MATERIALIZED_VIEW_REFRESH_FAILURE,
  UNLOCK_ALL_TAX_ENTRIES,
  UNLOCK_ALL_TAX_ENTRIES_SUCCESS,
  UNLOCK_ALL_TAX_ENTRIES_FAILURE,
  FETCH_ADMIN_JOBS,
  FETCH_ADMIN_JOBS_SUCCESS,
  FETCH_ADMIN_JOBS_FAILURE,
  RUN_ADMIN_JOB,
  RUN_ADMIN_JOB_SUCCESS,
  RUN_ADMIN_JOB_FAILURE,
  RUN_DEACTIVATE_USERS_JOB,
  RUN_DEACTIVATE_USERS_JOB_SUCCESS,
  RUN_DEACTIVATE_USERS_JOB_FAILURE,
  CLEAR_BSM_BALANCES,
  CLEAR_BSM_BALANCES_SUCCESS,
  CLEAR_BSM_BALANCES_FAILURE,
  SELECT_PERIODS,
  SELECT_COMPANY_CODES,
} from './types';

import initialState from './initialState';

function applicationSettingsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_APPLICATION_SETTINGS_FLAGS:
      return {
        ...state,
        applicationSettingsFlagsLoading: true,
      };
    case FETCH_APPLICATION_SETTINGS_FLAGS_SUCCESS:
      return {
        ...state,
        applicationSettingsFlags: { ...action.applicationSettingsFlags },
        applicationSettingsFlagsLoading: false,
      };
    case FETCH_APPLICATION_SETTINGS_FLAGS_FAILURE:
      return {
        ...state,
        applicationSettingsFlagsLoading: false,
      };
    case UPDATE_APPLICATION_SETTINGS_FLAGS:
      return {
        ...state,
        applicationSettingsFlagsUpdating: true,
      };
    case UPDATE_APPLICATION_SETTINGS_FLAGS_SUCCESS:
      return {
        ...state,
        applicationSettingsFlags: { ...action.applicationSettingsFlags },
        applicationSettingsFlagsUpdating: false,
      };
    case UPDATE_APPLICATION_SETTINGS_FLAGS_FAILURE:
      return {
        ...state,
        applicationSettingsFlagsUpdating: false,
      };
    case CLEAR_DEV_CACHE:
      return {
        ...state,
        devCacheClearing: true,
      };
    case CLEAR_DEV_CACHE_SUCCESS:
    case CLEAR_DEV_CACHE_FAILURE:
      return {
        ...state,
        devCacheClearing: false,
      };
    case MATERIALIZED_VIEW_REFRESH:
      return {
        ...state,
        materializedViewRefreshLoading: true,
      };
    case MATERIALIZED_VIEW_REFRESH_SUCCESS:
    case MATERIALIZED_VIEW_REFRESH_FAILURE:
      return {
        ...state,
        materializedViewRefreshLoading: false,
      };
    case UNLOCK_ALL_TAX_ENTRIES:
      return {
        ...state,
        unlockAllTaxEntriesLoading: true,
      };
    case UNLOCK_ALL_TAX_ENTRIES_SUCCESS:
    case UNLOCK_ALL_TAX_ENTRIES_FAILURE:
      return {
        ...state,
        unlockAllTaxEntriesLoading: false,
      };
    case FETCH_ADMIN_JOBS:
      return {
        ...state,
        adminJobsFetching: true,
      };
    case FETCH_ADMIN_JOBS_SUCCESS:
      return {
        ...state,
        adminJobsFetching: false,
        adminJobs: action.adminJobs,
      };
    case FETCH_ADMIN_JOBS_FAILURE:
      return {
        ...state,
        adminJobsFetching: false,
      };
    case RUN_ADMIN_JOB:
      return {
        ...state,
        adminJobInProgressName: action.jobName,
      };
    case RUN_ADMIN_JOB_SUCCESS:
    case RUN_ADMIN_JOB_FAILURE:
      return {
        ...state,
        adminJobInProgressName: null,
      };
    case RUN_DEACTIVATE_USERS_JOB:
      return {
        ...state,
        deactivateUsersJobInProgress: true,
      };
    case RUN_DEACTIVATE_USERS_JOB_SUCCESS:
    case RUN_DEACTIVATE_USERS_JOB_FAILURE:
      return {
        ...state,
        deactivateUsersJobInProgress: false,
      };
    default:
      return state;
    case CLEAR_BSM_BALANCES:
      return {
        ...state,
        clearBsmBalancesInProgress: true,
      };
    case CLEAR_BSM_BALANCES_SUCCESS:
    case CLEAR_BSM_BALANCES_FAILURE:
      return {
        ...state,
        clearBsmBalancesInProgress: false,
      };
    case SELECT_PERIODS:
      return {
        ...state,
        selectedPeriods: action.selectedPeriods,
      };
    case SELECT_COMPANY_CODES:
      return {
        ...state,
        selectedCompanyCodes: action.selectedCompanyCodes,
      };
  }
}

export default applicationSettingsReducer;
